<template>
  <div class="left">
    <div class="title">
      <p>客户中心</p>
      <span>Customer Center</span>
    </div>
    <div class="con">
      <router-link
        tag="a"
        :to="item.href"
        :class="item.active ? 'on' : ''"
        v-for="(item, index) in navlist"
        :key="index"
      >
        {{ item.title }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'left',
  data () {
    return {
      navlist: [
        {
          id: 1,
          title: '我的订单',
          href: this.$Router.order.path,
          active: this.$route.name === this.$Router.order.name
        },
        {
          id: 2,
          title: '查询对比',
          href: this.$Router.contrast.path,
          active: this.$route.name === this.$Router.contrast.name || this.$route.name === this.$Router.record.name
        },
        {
          id: 3,
          title: '发布文献',
          href: this.$Router.urliterature.path,
          active: this.$route.name === this.$Router.urliterature.name
        },
        {
          id: 4,
          title: '账号管理',
          href: this.$Router.userinfo.path,
          active: this.$route.name === this.$Router.userinfo.name
        }
      ]
    }
  },
  created () {
  }
}
</script>

<style lang="scss" scoped>
@import "./left.scss";
</style>



// WEBPACK FOOTER //
// src/components/customer/left/left.vue